import { AssistantPanel, useAssistantContext } from 'components/AiAssistant';
import {
    SidebarInset,
    SidebarProvider,
} from '@/ui/design-system/components/ui/sidebar';
import {
    useRootCategories,
    usePrefetchAffinityRoots,
    usePrefetchWatchlistsAndItems,
} from 'utils/hooks';
import { AgreeTermsAndTracking } from 'components';
import AppSidebar from 'components/AppSidebar';
import { useFlags } from 'utils/hooks/flags';
import ErrorBoundary from './ErrorBoundary';
import { memo } from 'react';
import { useLocation } from 'react-router-dom';

function getSidebarDefaultOpen() {
    const match = document.cookie.match(/(?:^|;\s*)sidebar_state=(\w+)/);
    return match ? match[1] === 'true' : true;
}

function LayoutContent({ children }) {
    const { pathname } = useLocation();
    const { isPanelOpen, closePanel } = useAssistantContext();

    return (
        <>
            <SidebarProvider defaultOpen={getSidebarDefaultOpen()}>
                <AppSidebar />
                <SidebarInset>
                    <div className="flex min-w-0 flex-col">
                        <div className="pb-16">
                            <ErrorBoundary key={pathname}>
                                {children}
                            </ErrorBoundary>
                        </div>
                    </div>
                </SidebarInset>
                <AssistantPanel isOpen={isPanelOpen} onClose={closePanel} />
            </SidebarProvider>
            <AgreeTermsAndTracking />
        </>
    );
}

function Layout({ children }) {
    useRootCategories();
    useFlags();
    usePrefetchWatchlistsAndItems();
    usePrefetchAffinityRoots();

    // AssistantProvider is now in Routes.jsx (above the Switch)
    // so state persists across route changes
    return <LayoutContent>{children}</LayoutContent>;
}

export default memo(Layout);
